<i18n>
  {
    "ru": {
      "auth_code": "Код авторизации",
      "bank_commission": "Комиссия банка, %",
      "card_number": "Номер карты",
      "currency": "Валюта",
      "date_complete": "Дата финансового завершения транзакции",
      "date_order_formation": "Дата и время формирования счёта",
      "fixed_fee": "Фиксированное вознаграждение",
      "order_num": "Номер счёта",
      "payer_full_name": "ФИО плательщика",
      "rrn": "RRN",
      "sub_merchant_name": "Наименование бенефициара",
      "sub_merchant_unp": "УНП бенефициара",
      "sum": "Сумма",
      "sum_commission": "Сумма комиссии",
      "sum_enrollment_sub_merchant": "Сумма зачисления на р/с бенефициару"
    }
  }
  </i18n>
  <template>
    <div style="margin: auto;max-width: 1175px;">
      <el-card>
        <el-form
          :model="filter"
          ref="searchForm"
          @submit.native.prevent="loadReports"
          :rules="filterRules"
        >
          <el-row :gutter="20">
            <el-col :sm="6">
              <el-form-item prop="time">
                <el-date-picker
                    v-model="filter.time"
                    type="daterange"
                    range-separator="|"
                    :unlink-panels="true"
                    :start-placeholder="$t('from')"
                    :end-placeholder="$t('to')"
                    align="right"
                  ></el-date-picker>
              </el-form-item>
            </el-col>

            <el-col :sm="5">
              <el-form-item prop="parent_billing_id">
                <el-select v-model="filter.parent_billing_id" clearable :placeholder="$t('parent_billing_id')">
                  <el-option v-for="(label, key) in parent_ids" :key="key" :label="label" :value="key"></el-option>
                </el-select>
              </el-form-item>
            </el-col>

            <el-col :sm="5">
              <el-form-item prop="sub_merchant_billing_id">
                <el-select v-model="filter.sub_merchant_billing_id" clearable :placeholder="$t('sub_merchant_billing_id')">
                  <el-option v-for="(label, key) in sub_merchant_ids" :key="key" :label="label" :value="key"></el-option>
                </el-select>
              </el-form-item>
            </el-col>

            <el-col :sm="2" class="aligner right" style="height: 60px">
              <el-button native-type="submit" size="small" round type="primary">{{$t('search')}}</el-button>
            </el-col>
            <el-col :sm="3" class="aligner right" style="height: 60px">
              <el-button :disabled="!csvUrl || tableData.length === 0" @click="csvUTF()" size="small" round>CSV (utf-8)</el-button>
            </el-col>
            <el-col :sm="3" class="aligner right" style="height: 60px">
              <el-button :disabled="!csvCPUrl || tableData.length === 0" @click="csvCP()" size="small" round>CSV (cp1251)</el-button>
            </el-col>
          </el-row>
        </el-form>

        <el-row>
          <el-table
            ref="table"
            class="small"
            :data="tableData"
            v-loading="loading"
            style="width: 100%"
          >
            <el-table-column prop="sub_merchant_unp" width="120" :label="$t('sub_merchant_unp')">
              <template slot-scope="scope">
                <span :data-label="scope.column.label" class="responsive-column">{{ scope.row.sub_merchant_unp }}</span>
              </template>
            </el-table-column>
            <el-table-column prop="sub_merchant_name" width="120" :label="$t('sub_merchant_name')">
              <template slot-scope="scope">
                <span :data-label="scope.column.label" class="responsive-column">{{ scope.row.sub_merchant_name }}</span>
              </template>
            </el-table-column>
            <el-table-column prop="payer_full_name" width="120" :label="$t('payer_full_name')">
              <template slot-scope="scope">
                <span :data-label="scope.column.label" class="responsive-column">{{ scope.row.payer_full_name }}</span>
              </template>
            </el-table-column>
            <el-table-column prop="order_num" width="120" :label="$t('order_num')">
              <template slot-scope="scope">
                <span :data-label="scope.column.label" class="responsive-column">{{ scope.row.order_num }}</span>
              </template>
            </el-table-column>
            <el-table-column prop="date_order_formation" width="120" :label="$t('date_order_formation')">
              <template slot-scope="scope">
                <span :data-label="scope.column.label" class="responsive-column">{{ scope.row.date_order_formation }}</span>
              </template>
            </el-table-column>
            <el-table-column prop="date_complete" width="140" :label="$t('date_complete')">
              <template slot-scope="scope">
                <span :data-label="scope.column.label" class="responsive-column">{{ scope.row.date_complete }}</span>
              </template>
            </el-table-column>
            <el-table-column prop="card_number" width="120" :label="$t('card_number')">
              <template slot-scope="scope">
                <span :data-label="scope.column.label" class="responsive-column">{{ scope.row.card_number }}</span>
              </template>
            </el-table-column>
            <el-table-column prop="auth_code" width="120" :label="$t('auth_code')">
              <template slot-scope="scope">
                <span :data-label="scope.column.label" class="responsive-column">{{ scope.row.auth_code }}</span>
              </template>
            </el-table-column>
            <el-table-column prop="rrn" width="120" :label="$t('rrn')">
              <template slot-scope="scope">
                <span :data-label="scope.column.label" class="responsive-column">{{ scope.row.rrn }}</span>
              </template>
            </el-table-column>
            <el-table-column prop="sum" width="120" :label="$t('sum')">
              <template slot-scope="scope">
                <span :data-label="scope.column.label" class="responsive-column">{{ scope.row.sum }}</span>
              </template>
            </el-table-column>
            <el-table-column prop="bank_commission" width="120" :label="$t('bank_commission')">
              <template slot-scope="scope">
                <span :data-label="scope.column.label" class="responsive-column">{{ scope.row.bank_commission }}</span>
              </template>
            </el-table-column>
            <el-table-column prop="sum_commission" width="120" :label="$t('sum_commission')">
              <template slot-scope="scope">
                <span :data-label="scope.column.label" class="responsive-column">{{ scope.row.sum_commission }}</span>
              </template>
            </el-table-column>
            <el-table-column prop="sum_enrollment_sub_merchant" width="140" :label="$t('sum_enrollment_sub_merchant')">
              <template slot-scope="scope">
                <span :data-label="scope.column.label" class="responsive-column">{{ scope.row.sum_enrollment_sub_merchant }}</span>
              </template>
            </el-table-column>
            <el-table-column prop="currency" width="120" :label="$t('currency')">
              <template slot-scope="scope">
                <span :data-label="scope.column.label" class="responsive-column">{{ scope.row.currency }}</span>
              </template>
            </el-table-column>
            <el-table-column prop="fixed_fee" width="130" :label="$t('fixed_fee')">
              <template slot-scope="scope">
                <span :data-label="scope.column.label" class="responsive-column">{{ scope.row.fixed_fee }}</span>
              </template>
            </el-table-column>
          </el-table>
        </el-row>

      </el-card>
    </div>
  </template>

  <script>
  import apiRes from '../../core/apiRes'

  export default {
    name: 'subTransactionsReports',
    data: () => ({
      filter: {
        time: [],
        parent_billing_id: null,
        sub_merchant_billing_id: null
      },

      filterRules: {
        time: { required: true, trigger: 'blur', message: ' ' },
        parent_billing_id: { required: true, trigger: 'blur', message: ' ' }
      },

      pagination: {
        total: 0,
        pageSize: 25,
        currentPage: 0
      },

      tableData: [],
      tableHeader: ['sub_merchant_unp', 'sub_merchant_name', 'payer_full_name', 'order_num', 'date_order_formation', 'date_complete', 'card_number', 'auth_code', 'rrn', 'sum', 'bank_commission', 'sum_commission', 'sum_enrollment_sub_merchant', 'currency', 'fixed_fee'],
      parent_ids: [],
      sub_merchant_ids: [],
      csvCPUrl: '',
      csvUrl: '',
      loading: false
    }),
    created() {
      apiRes.get(apiRes.subTransactionsReports).then(res => {
        res = res.page_vars
        this.parent_ids = res.idsParentBillings
        this.sub_merchant_ids = res.idsSubMerchantBillings
      }).finally(() => { this.loading = false })
    },
    methods: {
      csvUTF() {
        var link = document.createElement('a')
        link.setAttribute('href', apiRes.baseUrl + this.csvUrl)
        link.click()
        link.remove()
      },
      csvCP() {
        var link = document.createElement('a')
        link.setAttribute('href', apiRes.baseUrl + this.csvCPUrl)
        link.click()
        link.remove()
      },
      processResponse(vars) {
        console.log(vars)
        if (vars) {
          console.log(vars)
          const tableBody = vars.data.splice(1)
          console.log(tableBody)
          // проверка: если это объект с warning
          if (tableBody.length === 1 && tableBody[0].fixedCommissionWarningRow) {
            console.log(tableBody[0].fixedCommissionWarningRow)
            this.$notify.warning({
              title: this.$t('warning'),
              message: tableBody[0].fixedCommissionWarningRow
            })
            this.tableData = []
            return
          }
          this.csvCPUrl = vars.url_export_csv_cp1251
          this.csvUrl = vars.url_export_csv

          this.tableData = tableBody.reduce((acc, curr) => {
            const tableRow = curr.reduce((acc2, curr2, index2) => {
              return { ...acc2, [this.tableHeader[index2]]: curr2 }
            }, {})

            return [ ...acc, tableRow ]
          }, [])
        } else {
          this.tableData = []
        }
      },
      parseReports(promise) {
        this.loading = true
        this.tableData = []
        promise.then((data) => {
          this.processResponse(data.page_vars)
          this.loading = false
        }).catch((err) => {
          console.error('API ERROR: ', err)
          this.$notify.error({
            title: this.$t('error'),
            message: ''
          })
          this.loading = false
        })
      },
      loadReports() {
        this.$refs['searchForm'].validate((valid) => {
          if (this.filter.time && this.filter.time.length === 2 && this.filter.parent_billing_id) {
            this.loading = true
            const request = {}

            const parts = this.filter.time.map(d => d.toLocaleDateString('en-CA').slice(0, 10))
            request.date_from = parts[0]
            request.date_to = parts[1]
            console.log(request.date_from)
            console.log(request.date_to)
            request.parentBillingId = this.filter.parent_billing_id
            request.subMerchantBillingId = this.filter.sub_merchant_billing_id
            this.parseReports(apiRes.post(apiRes.subTransactionsReports, request))
          }
        })
      }
    }
  }
  </script>
  <style>
  .el-table__footer-wrapper {
    font-weight: bold;
  }
  .el-table__footer-wrapper tr td:first-child .cell {
    text-align: left;
  }
  </style>
